// extracted by mini-css-extract-plugin
export default {"root":"Form_root__Gk0OJ","header":"Form_header__r3Uvz","content":"Form_content__GE8LP"};